import { AxiosResponse } from 'axios';

// Models
import { Result } from '@/main/models/common/resultResponse';
import { QuoteItemCommentRequest } from '@/main/models/request';
import {
  QuoteItemCommentHeaderResponse,
  QuoteItemCommentResponse
} from '@/main/models/response';

export abstract class IQuoteItemCommentApi {
  abstract getCommentsHeaderByQuoteItem(
    guidQuoteItem: string
  ): Promise<AxiosResponse<Result<QuoteItemCommentHeaderResponse>>>;
  abstract getCommentsByQuoteItem(
    guidQuoteItem: string
  ): Promise<AxiosResponse<Result<QuoteItemCommentResponse[]>>>;
  abstract save(
    request: QuoteItemCommentRequest
  ): Promise<AxiosResponse<Result<any>>>;
}

